import styled from "styled-components";

export const Wrapper = styled.div`
    /* width: ${64 * 4 + 42 * 8}px; */
    width: fit-content;
    height: ${64 * 3.5}px;
    position: relative;
    margin: auto;
    display: flex;
`;
